module.exports = __webpack_public_path__ + "static/media/Acrilico (28).ab054a47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (28).jpg
// module id = 296
// module chunks = 0